<template>
    <v-flex xs12 class="related-products-inline">
    	<v-sheet color="grey lighten-3" class="selected-products-wrapper mb-3">
			<selected-product-card 
				v-if="hasProducts"
				v-for="(product, index) in products" 
				:key="index" 
				:product="product" 
				class="selected-product-card" 
				@on-remove="handleRemove(product)">					
			</selected-product-card>
    	</v-sheet>
		<v-navigation-drawer
			v-model="pickingProducts"
			:width="clientWidth"
			fixed
			right
			temporary
			class="related-content-list-picker pa-3"
			@input="handleDrawerToggled">

			<product-list class="pa-0" :action="handleAction" :selected-products="products"></product-list>
		</v-navigation-drawer>
		<v-btn class="btn-add-product" small dark fab @click="pickingProducts = true">
			<v-icon>add</v-icon>
        </v-btn>
 	</v-flex>	
</template>

<script>
	import * as config from '@/config'

	import ProductList from '@/components/ProductList.vue'
	import SelectedProductCard from '@/components/SelectedProductCard.vue'

	export default {
		props: ['value'],
		components: {
			'product-list': ProductList,
			'selected-product-card': SelectedProductCard
		},
		data () {
			return {
				products: [],
				pickingProducts: false,
			}
		},
		computed: {
			clientWidth () 
			{
				return (window.innerWidth > 640) ? 640 : window.innerWidth
			},
			hasProducts () {
				return (this.products) ? (this.products.length > 0) : false
			}
		},
		methods: {
			handleDrawerToggled (value)
			{
				if (!value) this.$emit('close')
			},
			handleSearch ()
			{

			},
			handleReset ()
			{

			},
			handleAction (item)
			{
				var index = this.products.indexOf(item)

				if (index < 0) {
					this.products.push(item)
				}
			},
			handleRemove (item)
			{
				if (confirm("Remove " + item.title + "?")) {
					var index = this.products.indexOf(item)

					this.products.splice(index, 1)
				}
			},
			initComponent ()
			{
				this.products = this.value
			}
		},
		mounted () {
			this.$nextTick(this.initComponent)
		},
		watch: {
			products (value) {
				this.$emit('input', this.products)
			},
			value (props) {
				this.initComponent()
			}
		}
	}
</script>

<style lang="scss">
	.related-products-inline {
		position: relative;

		.btn-add-product {
			position: absolute;
			right: .5rem;
			bottom: .5rem;
		}

		.search-result {
			.v-card__text {
				padding: 0;
			}
		}
	}
	.selected-products-wrapper {
		display: flex;
		overflow-x: scroll;
		overflow-y: hidden;
		white-space: nowrap;

		height: 225px;

		.selected-product-card {
			display: inline-block;
			width: 128px;
			margin: 10px;

			.v-card__title {
				padding: 10px;
				white-space: pre-wrap;
			}
		}
	}
</style>